var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 399.808,
    viewBox: "0 0 512 399.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -56.096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.108,359.384V409.6c0,21.52-53.407,38.969-119.289,38.969-42.836,0-80.4-7.377-101.432-18.457-11.314-5.952-17.847-12.983-17.847-20.512V359.384Z",
    fill: "#efae2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.54,359.384h73.675a166.716,166.716,0,0,1-55.829,70.725c-11.314-5.952-17.847-12.983-17.847-20.512V359.384Z",
    fill: "#e59120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.108,359.384c0,21.53-53.407,38.98-119.289,38.98-23.514,0-45.44-2.228-63.918-6.074-33.282-6.909-55.361-19.057-55.361-32.9,0-9.778,11.019-18.721,29.232-25.569,14.438-5.423,33.424-9.544,54.995-11.7,11.08-1.109,22.852-1.709,35.052-1.709,61.659,0,112.39,15.283,118.628,34.889A13.14,13.14,0,0,1,478.108,359.384Z",
    fill: "#ffe28f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.447,355.294c-23.28,7.082-53.183,10.948-84.725,10.948-28.378,0-55.188-3.083-77.532-8.923-25.091-6.552-39.03-15.038-46.417-23.5,14.438-5.423,33.424-9.544,54.995-11.7,11.08-1.109,22.852-1.709,35.052-1.709C420.478,320.4,471.209,335.687,477.447,355.294Z",
    fill: "#ffd243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.767,322.114A164.815,164.815,0,0,1,294.9,392.289c-33.282-6.909-55.361-19.057-55.361-32.9C239.54,341.843,275,327.008,323.767,322.114Z",
    fill: "#ffd243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,264.851v50.212c0,21.52-53.407,38.969-119.279,38.969-28.153,0-54.038-3.2-74.449-8.526-27.33-7.132-44.83-18.121-44.83-30.443V264.851Z",
    fill: "#efae2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.832,295.935a165.313,165.313,0,0,1-7.56,49.571c-27.33-7.132-44.83-18.121-44.83-30.443V264.851h49.47A166.461,166.461,0,0,1,325.832,295.935Z",
    fill: "#e59120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,264.851c0,21.52-53.407,38.969-119.279,38.969-24.786,0-47.821-2.473-66.9-6.7-31.613-7.021-52.38-18.854-52.38-32.274a13.41,13.41,0,0,1,.682-4.172c3.266-10.042,18.2-18.945,40.292-25.233,20.95-5.962,48.34-9.574,78.3-9.574,35.917,0,68.13,5.189,90,13.4C500.96,246.109,512,255.062,512,264.851Z",
    fill: "#ffe28f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.717,239.271c-6.257,7.143-17.216,14.367-35.754,20.421-23.728,7.743-55.025,12.016-88.144,12.016a362.222,362.222,0,0,1-38.786-2.035c-9.371-1.017-27.879-3.541-45.909-8.995,3.266-10.042,18.2-18.945,40.292-25.233,20.95-5.962,48.34-9.574,78.3-9.574C428.638,225.871,460.851,231.06,482.717,239.271Z",
    fill: "#ffd243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.832,295.935c0,.4,0,.794-.01,1.19-31.613-7.021-52.38-18.854-52.38-32.274,0-11.732,15.862-22.262,40.974-29.4A165.055,165.055,0,0,1,325.832,295.935Z",
    fill: "#ffd243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.108,170.317v50.2c0,21.53-53.407,38.98-119.289,38.98a350.57,350.57,0,0,1-37.473-1.964c-47.516-5.128-81.8-19.77-81.8-37.016v-50.2Z",
    fill: "#efae2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.54,220.519v-50.2h28.632a166.085,166.085,0,0,1,53.173,87.218C273.829,252.407,239.54,237.765,239.54,220.519Z",
    fill: "#e59120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.108,170.317c0,6.9-5.494,13.39-15.14,19.007-20.411,11.915-59.4,19.963-104.149,19.963a322.589,322.589,0,0,1-60.987-5.484c-34.91-6.787-58.291-19.251-58.291-33.485,0-5.209,3.124-10.175,8.791-14.7a62.88,62.88,0,0,1,13.034-7.763c21.6-9.992,57.2-16.514,97.454-16.514C424.7,131.337,478.108,148.787,478.108,170.317Z",
    fill: "#ffe28f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.108,170.317c0,6.9-5.494,13.39-15.14,19.007-20.634,4.65-44.912,7.143-70.247,7.143-33.119,0-64.416-4.263-88.134-12.016-33.231-10.857-42.113-25.447-43.222-36.6,21.6-9.992,57.2-16.514,97.454-16.514C424.7,131.337,478.108,148.787,478.108,170.317Z",
    fill: "#ffd243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.54,170.317c0-5.209,3.124-10.175,8.791-14.7a167.031,167.031,0,0,1,49.5,48.188C262.922,197.015,239.54,184.551,239.54,170.317Z",
    fill: "#ffd243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.438,95.075v50.21c0,21.526,53.4,38.975,119.281,38.975S512,166.81,512,145.285V95.075",
    fill: "#efae2e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.28,
    cy: 38.976,
    rx: 119.28,
    ry: 38.976,
    transform: "translate(273.44 56.096)",
    fill: "#ffe28f"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.66,
    cy: 153.66,
    r: 153.66,
    transform: "translate(6.31 142.272)",
    fill: "#efae2e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.971,423.821A127.887,127.887,0,1,1,287.857,295.935,128.032,128.032,0,0,1,159.971,423.821Z",
    fill: "#e59120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.68,
    cy: 115.68,
    r: 115.68,
    transform: "translate(44.29 180.252)",
    fill: "#ffe28f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.6,313.168a24.894,24.894,0,0,0-23.827-24.843c-.19-.014-.382-.021-.575-.021a9.6,9.6,0,1,1,7.449-15.664A7.631,7.631,0,1,0,179.481,263a24.789,24.789,0,0,0-11.648-7.96v-3.9a7.631,7.631,0,1,0-15.262,0v3.9a24.864,24.864,0,0,0,6.594,48.506c.19.014.382.021.575.021a9.6,9.6,0,1,1-7.45,15.662,7.631,7.631,0,0,0-11.828,9.646,24.8,24.8,0,0,0,12.109,8.105v3.751a7.631,7.631,0,1,0,15.262,0v-4.055A24.907,24.907,0,0,0,184.6,313.168Z",
    fill: "#e59120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.429,303.565h-.039a7.675,7.675,0,0,1-7.644-7.669,7.588,7.588,0,0,1,7.579-7.594h.14a7.631,7.631,0,0,1-.036,15.262Z",
    fill: "#e59120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.617,303.565h-.039a7.675,7.675,0,0,1-7.644-7.669,7.588,7.588,0,0,1,7.579-7.594h.14a7.631,7.631,0,0,1-.036,15.262Z",
    fill: "#e59120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.971,185.064a7.631,7.631,0,0,1-7.631-7.631V143.6a7.631,7.631,0,0,1,15.262,0v33.838A7.631,7.631,0,0,1,159.971,185.064Z",
    fill: "#ffd243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.971,455.9a7.631,7.631,0,0,1-7.631-7.631V414.435a7.631,7.631,0,1,1,15.262,0v33.838A7.63,7.63,0,0,1,159.971,455.9Z",
    fill: "#ffd243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.31,303.565H278.472a7.631,7.631,0,0,1,0-15.262H312.31a7.631,7.631,0,0,1,0,15.262Z",
    fill: "#ffd243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.469,303.565H7.631a7.631,7.631,0,0,1,0-15.262H41.469a7.631,7.631,0,0,1,0,15.262Z",
    fill: "#ffd243"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.0ab02ea004233a19a0c2d36b9216eccd.svg";
export { ForwardRef as ReactComponent };